const init = () => {
    document.querySelectorAll('.component-pannel-filters').forEach(element => {
        const navigation_buttons = element.querySelectorAll('.component-pannel-filters__navigation button')
        const reset_button = element.querySelector('.component-pannel-filters__reset-button')
        const apply_button = element.querySelector('.component-pannel-filters__apply-button')
        const pannels_taxonomy = element.querySelectorAll('.component-pannel-filters__filter-taxonomy')
        const date_buttons = element.querySelectorAll('.component-pannel-filters__filter-dates button')

        // Déterminer le type de pannel en fonction de son ID
        const pannelId = element.closest('[id]')?.id
        const isAgendaPannel = pannelId === 'filters-js'
        const agenda_list = document.querySelector('#filter-js')

        // Si c'est le pannel agenda, initialiser le message "aucun résultat"
        if (isAgendaPannel && agenda_list) {
            const noResultsMessage = document.createElement('div')
            noResultsMessage.className = 'no-results-message'
            noResultsMessage.style.display = 'none'
            noResultsMessage.style.textAlign = 'center'
            noResultsMessage.style.padding = '2rem'
            noResultsMessage.style.fontSize = '1.2rem'
            noResultsMessage.style.color = '#666'
            noResultsMessage.innerHTML = 'Aucun événement ne correspond à vos critères de recherche'
            agenda_list.appendChild(noResultsMessage)
        }

        let current_open_button = null

        // Navigation
        if (navigation_buttons.length > 0) {
            navigation_buttons.forEach(button => {
                button.addEventListener('click', () => {
                    const target = button.getAttribute('data-filter-target')
    
                    navigation_buttons.forEach(b => b.classList.remove('active'))
                    button.classList.add('active')
                    element.querySelectorAll('.component-pannel-filters__content > div').forEach(pannel => pannel.classList.remove('active'))
                    element.querySelector('[data-filter="' + target + '"]').classList.add('active')
                })
            })
        }

        // Taxonomies
        pannels_taxonomy.forEach(pannel => {
            const buttons = pannel.querySelectorAll('button')

            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    if (!isAgendaPannel) {
                        // Logique pour la page saison
                        buttons.forEach(button => button.classList.remove('active'))
                        button.classList.add('active')
                    } else {
                        // Logique pour l'agenda
                        if (button.classList.contains('active')) {
                            button.classList.remove('active')
                            return
                        }
                        buttons.forEach(btn => btn.classList.remove('active'))
                        button.classList.add('active')
                    }
                })
            })
        })

        // Dates
        date_buttons.forEach(button => {
            button.addEventListener('click', () => {
                if (button.classList.contains('active')) {
                    button.classList.remove('active')
                    return
                }
                date_buttons.forEach(button => button.classList.remove('active'))
                button.classList.add('active')
            })
        })

        // Réinitialisation
        reset_button.addEventListener('click', () => {
            if (!isAgendaPannel) {
                // Logique pour la page saison
                document.dispatchEvent(new CustomEvent('ClosePannel'))
                setTimeout(() => {
                    const url = new URL(window.location.href)
                    window.swup.navigate(url.origin + url.pathname)
                }, data?.transitions?.secondary?.duration ? data.transitions.secondary.duration : 1400)
            } else {
                // Logique pour l'agenda
                pannels_taxonomy.forEach(pannel => {
                    const buttons = pannel.querySelectorAll('button')
                    buttons.forEach(btn => btn.classList.remove('active'))
                })
                date_buttons.forEach(btn => btn.classList.remove('active'))
                if (agenda_list) {
                    filterAgendaPosts()
                }
            }
        })

        // Application
        apply_button.addEventListener('click', () => {
            if (!isAgendaPannel) {
                // Logique pour la page saison
                const period_active = element.querySelector('[data-period].active')
                const museum_active = element.querySelector('.component__pannel-museums button.active')
                const url = new URL(window.location.href)
                const search_params = url.searchParams

                // Ajouter les données des taxonomies dans l'URL
                let taxonomies_parameter = []

                pannels_taxonomy.forEach(pannel => {
                    const active = pannel.querySelector('button.active:not([data-term="all"])')
                    
                    if (active) {
                        taxonomies_parameter.push(pannel.getAttribute('data-filter') + ',' + active.getAttribute('data-term'))
                    }
                })

                if (taxonomies_parameter.length > 0) {
                    search_params.set('taxonomies', taxonomies_parameter.join('|'))
                } else {
                    search_params.delete('taxonomies')
                }

                // Ajouter les données de la période dans l'URL
                if (period_active) {
                    search_params.set('period', period_active ? period_active.getAttribute('data-period') : '')
                } else {
                    search_params.delete('period')
                }

                // Ajouter les données du musée dans l'URL
                if (museum_active) {
                    search_params.set('_museum', museum_active ? museum_active.getAttribute('data-museum') : '')
                } else {
                    search_params.delete('_museum')
                }

                document.dispatchEvent(new CustomEvent('ClosePannel'))

                setTimeout(() => {
                    window.history.pushState({}, '', url)
                    window.swup.navigate(url.href)
                }, data?.transitions?.secondary?.duration ? data.transitions.secondary.duration : 1400)
            } else {
                // Logique pour l'agenda
                if (agenda_list) {
                    filterAgendaPosts()
                }
                // Fermer le pannel après application
                const closeButton = element.querySelector('[data-pannel-close]')
                if (closeButton) {
                    closeButton.click()
                }
            }
        })

        // Fonction de filtrage des posts pour l'agenda
        const filterAgendaPosts = () => {
            if (!agenda_list) return

            const posts = agenda_list.querySelectorAll('.card-spectacle')
            if (!posts.length) return

            let active_filters = {
                dates: null,
                genre: null,
                lieux: null,
                public: null,
                festival: null
            }

            // Récupérer les filtres actifs
            pannels_taxonomy.forEach(pannel => {
                const active_button = pannel.querySelector('button.active')
                if (active_button) {
                    const filter_type = pannel.getAttribute('data-filter')
                    const term = active_button.getAttribute('data-term')
                    active_filters[filter_type] = term === 'all' ? null : term
                }
            })

            const period_active = element.querySelector('[data-period].active')
            if (period_active) {
                active_filters.dates = period_active.getAttribute('data-period')
            }

            // Vérifier si des filtres sont actifs
            const hasActiveFilters = Object.values(active_filters).some(value => value !== null)
            
            // Récupérer toutes les sections (groupes de posts)
            const sections = agenda_list.querySelectorAll('.flex.flex-col.gap-xl')
            let totalVisiblePosts = 0
            
            sections.forEach(section => {
                const sectionPosts = section.querySelectorAll('.card-spectacle')
                let hasVisiblePosts = false

                sectionPosts.forEach(post => {
                    let should_show = true

                    // Si aucun filtre n'est actif, tout afficher
                    if (!hasActiveFilters) {
                        post.style.display = 'block'
                        hasVisiblePosts = true
                        totalVisiblePosts++
                        return
                    }

                    // Vérifier tous les filtres actifs
                    Object.entries(active_filters).forEach(([key, value]) => {
                        if (value) {
                            if (key === 'dates') {
                                const post_date = post.getAttribute('data-date')
                                if (!post_date || !isDateInRange(post_date, value)) {
                                    should_show = false
                                }
                            } else {
                                const post_terms = post.getAttribute(`data-${key}`)?.split(',') || []
                                if (!post_terms.includes(value)) {
                                    should_show = false
                                }
                            }
                        }
                    })

                    // Appliquer le style d'affichage
                    post.style.display = should_show ? 'block' : 'none'
                    if (should_show) {
                        hasVisiblePosts = true
                        totalVisiblePosts++
                    }
                })

                // Gérer l'affichage du titre de section
                const sectionTitle = section.previousElementSibling
                if (sectionTitle && sectionTitle.tagName === 'H2') {
                    sectionTitle.style.display = hasVisiblePosts ? 'block' : 'none'
                }
            })

            // Afficher ou masquer le message "aucun résultat"
            const noResultsMessage = agenda_list.querySelector('.no-results-message')
            if (noResultsMessage) {
                noResultsMessage.style.display = totalVisiblePosts === 0 ? 'block' : 'none'
            }
        }

        // Fonction utilitaire pour vérifier si une date est dans la plage
        const isDateInRange = (date, range) => {
            const postDate = new Date(date)
            const [year, month] = range.split('-')
            return postDate.getFullYear() === parseInt(year) && 
                   postDate.getMonth() === parseInt(month) - 1
        }

        // Défaut
        if (navigation_buttons.length > 0) {
            navigation_buttons[0].classList.add('active')
            element.querySelector('[data-filter="' + navigation_buttons[0].getAttribute('data-filter-target') + '"]').classList.add('active')
        } else {
            element.querySelector('[data-filter]').classList.add('active')
        }
    })
}

document.addEventListener('ContentLoaded', init)
document.addEventListener('NewContentLoaded', init)